import React from "react";
import { LabeledText } from "sprint-common-web";

import { DeliveryEndpointType } from "../../../../common/types/DeliveryEndpointType";
import { useDeliveryInfo } from "./useDeliveryInfo";

export const DeliveryInfo: React.VFC = () => {
    const { deliveryEndpoint, distributionList } = useDeliveryInfo();

    switch (deliveryEndpoint?.details.type) {
        case DeliveryEndpointType.Smartjog:
            return (
                <>
                    <LabeledText
                        label="Type"
                        value={DeliveryEndpointType[deliveryEndpoint.details.type]}
                        maxLength={40}
                    />
                    <LabeledText label="Delivery endpoint" value={deliveryEndpoint?.name} maxLength={40} />
                    <LabeledText label="Distribution list" value={distributionList?.name} maxLength={40} />
                </>
            );

        case DeliveryEndpointType.Aspera:
            return (
                <>
                    <LabeledText
                        label="Type"
                        value={DeliveryEndpointType[deliveryEndpoint.details.type]}
                        maxLength={40}
                    />
                    <LabeledText label="Delivery endpoint" value={deliveryEndpoint?.name} maxLength={40} />
                </>
            );
        case DeliveryEndpointType.Signiant:
            return (
                <>
                    <LabeledText
                        label="Type"
                        value={DeliveryEndpointType[deliveryEndpoint.details.type]}
                        maxLength={41}
                    />
                    <LabeledText label="Delivery endpoint" value={deliveryEndpoint?.name} maxLength={40} />
                </>
            );

        default: {
            return (
                <>
                    <LabeledText label="Type" value={undefined} maxLength={40} />
                    <LabeledText label="Delivery endpoint" value={undefined} maxLength={40} />
                </>
            );
        }
    }
};
